<!-- START Sidebar (left)-->
<div class="aside-inner">
  <nav
    class="sidebar"
    sidebar-anyclick-close=""
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
  >
    <!-- START sidebar nav-->
    <ul class="sidebar-nav">
      <li>
        <a (click)="toggleCollapsedSideabar($event)" (mouseenter)="toggleSubmenuHover($event)">
          <em class="icon-menu"></em>
        </a>
      </li>

      @for (item of menuItems; track trackByMenuItem($index, item)) {
      <li
        [ngClass]="{ 'nav-heading': item.heading }"
        [routerLinkActive]="
          !item.submenu && !item.heading && item.link ? ['active'] : []
        "
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <!-- menu heading -->
        @if (item.heading && item.text !== 'Main Menu' && item.text !== 'Bot
        Menu') {
        <span>{{ (item.translate | translate) || item.text }}</span>
        }
        <!-- external links -->
        @if (!item.heading && !item.submenu && item.elink) {
        <a
          href
          [attr.target]="item.target"
          [attr.href]="item.elink"
          title="{{ item.text }}"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.icon) {
          <em class="{{ item.icon }}"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
        <!-- single menu item -->
        @if (!item.heading && !item.submenu && !item.elink && item.link) {
        <a
          href
          [routerLink]="item.link"
          [attr.route]="item.link"
          title="{{ item.text }}"
          (click)="toggleSubmenuClick($event)"
          (mouseenter)="toggleSubmenuHover($event)"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.icon) {
          <em class="{{ item.icon }}"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
        <!-- has submenu -->
        @if (!item.heading && item.submenu) {
        <a
          href
          title="{{ item.text }}"
          (click)="toggleSubmenuClick($event)"
          (mouseenter)="toggleSubmenuHover($event)"
        >
          @if (item.alert) {
          <span
            class="float-right"
            [ngClass]="item.label || 'badge badge-success'"
            >{{ item.alert }}</span
          >
          } @if (item.icon) {
          <em class="{{ item.icon }}"></em>
          }
          <span>{{ (item.translate | translate) || item.text }}</span>
        </a>
        }
        <!-- SUBLEVEL -->
        @if (item.submenu) {
        <ul class="sidebar-nav sidebar-subnav" [routerLinkActive]="['opening']">
          <li class="sidebar-subnav-header">
            {{ (item.translate | translate) || item.text }}
          </li>
          @for (subitem of item.submenu; track trackByMenuItem($index, subitem))
          {
          <li [routerLinkActive]="subitem.link ? ['active'] : []">
            <!-- sublevel: external links -->
            @if (!subitem.heading && !subitem.submenu && subitem.elink) {
            <a
              href
              [attr.target]="subitem.target"
              [attr.href]="subitem.elink"
              title="{{ subitem.text }}"
            >
              @if (subitem.alert) {
              <span
                class="float-right"
                [ngClass]="subitem.label || 'badge badge-success'"
                >{{ subitem.alert }}</span
              >
              } @if (subitem.icon) {
              <em class="{{ subitem.icon }}"></em>
              }
              <span>{{ (subitem.translate | translate) || subitem.text }}</span>
            </a>
            }
            <!-- sublevel: single menu item  -->
            @if (!subitem.submenu && !subitem.elink && subitem.link) {
            <a
              href
              [routerLink]="subitem.link"
              [attr.route]="subitem.link"
              title="{{ subitem.text }}"
            >
              @if (subitem.alert) {
              <span
                class="float-right"
                [ngClass]="subitem.label || 'badge badge-success'"
                >{{ subitem.alert }}</span
              >
              } @if (subitem.icon) {
              <em class="{{ subitem.icon }}"></em>
              }
              <span>{{ (subitem.translate | translate) || subitem.text }}</span>
            </a>
            }
            <!-- sublevel: has submenu -->
            @if (subitem.submenu) {
            <a
              href
              title="{{ subitem.text }}"
              (click)="toggleSubmenuClick($event)"
              (mouseenter)="toggleSubmenuHover($event)"
            >
              @if (subitem.alert) {
              <span
                class="float-right"
                [ngClass]="subitem.label || 'badge badge-success'"
                >{{ subitem.alert }}</span
              >
              } @if (subitem.icon) {
              <em class="{{ subitem.icon }}"></em>
              }
              <span>{{ (subitem.translate | translate) || subitem.text }}</span>
            </a>
            }
            <!-- SUBLEVEL 2 -->
            @if (subitem.submenu) {
            <ul
              class="sidebar-nav sidebar-subnav level2"
              [routerLinkActive]="['opening']"
            >
              @for (subitem2 of subitem.submenu; track trackByMenuItem($index,
              subitem2)) {
              <li [routerLinkActive]="['active']">
                <!-- sublevel 2: single menu item  -->
                @if (!subitem2.submenu) {
                <a
                  href
                  [routerLink]="subitem2.link"
                  [attr.route]="subitem2.link"
                  title="{{ subitem2.text }}"
                >
                  @if (subitem2.alert) {
                  <span
                    class="float-right"
                    [ngClass]="subitem2.label || 'badge badge-success'"
                    >{{ subitem2.alert }}</span
                  >
                  } @if (subitem2.icon) {
                  <em class="{{ subitem2.icon }}"></em>
                  }
                  <span>{{
                    (subitem2.translate | translate) || subitem2.text
                  }}</span>
                </a>
                }
                <!-- sublevel2: has submenu -->
                @if (subitem2.submenu) {
                <a
                  href
                  title="{{ subitem2.text }}"
                  (click)="toggleSubmenuClick($event)"
                  (mouseenter)="toggleSubmenuHover($event)"
                >
                  @if (subitem2.alert) {
                  <span
                    class="float-right"
                    [ngClass]="subitem2.label || 'badge badge-success'"
                    >{{ subitem2.alert }}</span
                  >
                  } @if (subitem2.icon) {
                  <em class="{{ subitem2.icon }}"></em>
                  }
                  <span>{{
                    (subitem2.translate | translate) || subitem2.text
                  }}</span>
                </a>
                }
                <!-- SUBLEVEL 3 -->
                @if (subitem2.submenu) {
                <ul
                  class="sidebar-nav sidebar-subnav level3"
                  [routerLinkActive]="['opening']"
                >
                  @for (subitem3 of subitem2.submenu; track
                  trackByMenuItem($index, subitem3)) {
                  <li [routerLinkActive]="['active']">
                    <!-- sublevel 3: single menu item  -->
                    @if (!subitem3.submenu) {
                    <a
                      href
                      [routerLink]="subitem3.link"
                      [attr.route]="subitem3.link"
                      title="{{ subitem3.text }}"
                    >
                      @if (subitem3.alert) {
                      <span
                        class="float-right"
                        [ngClass]="subitem3.label || 'badge badge-success'"
                        >{{ subitem3.alert }}</span
                      >
                      } @if (subitem3.icon) {
                      <em class="{{ subitem3.icon }}"></em>
                      }
                      <span>{{
                        (subitem3.translate | translate) || subitem3.text
                      }}</span>
                    </a>
                    }
                    <!-- sublevel3: has submenu -->
                    @if (subitem3.submenu) {
                    <a
                      href
                      title="{{ subitem3.text }}"
                      (click)="toggleSubmenuClick($event)"
                      (mouseenter)="toggleSubmenuHover($event)"
                    >
                      @if (subitem3.alert) {
                      <span
                        class="float-right"
                        [ngClass]="subitem3.label || 'badge badge-success'"
                        >{{ subitem3.alert }}</span
                      >
                      } @if (subitem3.icon) {
                      <em class="{{ subitem3.icon }}"></em>
                      }
                      <span>{{
                        (subitem3.translate | translate) || subitem3.text
                      }}</span>
                    </a>
                    <!-- SUBLEVEL 4 -->
                    @if (subitem3.submenu) {
                    <ul
                      class="sidebar-nav sidebar-subnav level3"
                      [routerLinkActive]="['opening']"
                    >
                      @for (subitem4 of subitem3.submenu; track
                      trackByMenuItem($index, subitem4)) {
                      <li [routerLinkActive]="['active']">
                        <!-- sublevel 4: single menu item  -->
                        @if (!subitem4.submenu) {
                        <a
                          href
                          [routerLink]="subitem4.link"
                          [attr.route]="subitem4.link"
                          title="{{ subitem4.text }}"
                        >
                          @if (subitem4.alert) {
                          <span
                            class="float-right"
                            [ngClass]="subitem4.label || 'badge badge-success'"
                            >{{ subitem4.alert }}</span
                          >
                          } @if (subitem4.icon) {
                          <em class="{{ subitem4.icon }}"></em>
                          }
                          <span>{{
                            (subitem4.translate | translate) || subitem4.text
                          }}</span>
                        </a>
                        }
                      </li>
                      }
                    </ul>
                    } }
                  </li>
                  }
                </ul>
                }
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </li>
      }
    </ul>
    <!-- END sidebar nav-->
  </nav>
</div>
<!-- END Sidebar (left)-->
